export default {
  authLogin: (state, auth) => {
    state.authToken = auth.authToken
    state.userDetails = auth.user
    state.isLoggedIn = true
  },
  logout: (state) => {
    state.isLoggedIn = false
    state.authToken = ''
  },
  showDeleteDialog: (state, data) => {
    /*  */
    state.dialogOkCb = data.dialogOkCb || function () { }
    state.dialogCancelCb = data.cancelCb || function () { }
    state.isLocalDelete = data.isLocalDelete || false
    /*  */
    state.deletePayload = data
    state.showDialog = true
  },
  hideDialog: (state) => {
    state.showDialog = false
  },
  rememberOrder: (state, obj) => {
    state[obj.type] = obj.data
  },
  applyFilterOnOrder: (state, obj) => {
    state.filterByActiveUser = obj
  },
  isChangesMade (state, data) {
    state.isChangesMade = data
  },
  changeSaveUpdateDialog (state, data) {
    state.changeSaveUpdateDialog = data
  },
  changeLostDialog (state, data) {
    state.changeLostDialog = data
  },
  dialogOk (state) {
    state.dialogOkCb()
    state.showDialog = false
  },
  // REMEBER FILTERS
  rememberFilter (state, obj) {
    state[obj.type] = obj.data
  },
  supportingList: (state, data) => {
    state.supportList = data
  },
  listValues: (state, obj) => {
    /* let record = state.supportList.lastAddedRecord
    if (record && record.id) {
      let addedItemIndex = obj.data.findIndex(x => x.id === record.id)
      if (addedItemIndex > -1) obj.data[addedItemIndex].setToField = true
    } */
    state[obj.type] = obj.data
  },
  saveFilter (state, obj) {
    state[obj.type] = obj.data
  }
}
